import { PROGRAM_ITEMS } from "../config/slides";

export function ProgramSlide() {
  return (
    <article className="content-slide program-slide">
      <div className="slide-copy">
        <p className="slide-kicker"><span>01</span> TONIGHT&apos;S PROGRAM</p>
        <h2>前夜祭プログラム</h2>
        <p className="slide-lead">まもなく開演。5つの企画をお楽しみください。</p>
      </div>
      <ol className="program-list">
        {PROGRAM_ITEMS.map((item, index) => (
          <li key={item}>
            <span>{String(index + 1).padStart(2, "0")}</span>
            <strong>{item}</strong>
          </li>
        ))}
      </ol>
    </article>
  );
}
